import React from "react";
import { formatText } from "../../utils/formatters";

// (2026-05-15) Rediseño Sirius. Igual que ModalClients, este modal usaba
// `class=` (no `className`) por lo que React ignoraba los estilos y todo el
// contenido vivía dentro del header sin scroll. Reescrito al patrón estándar
// conservando los bindings de `message` (modelo Cliente).
function ModalEndClients({ isOpen, onClose, message }) {
  if (!isOpen) return null;

  const Item = ({ label, children, full }) => (
    <div className={full ? "w-full" : "w-full sm:w-1/2 lg:w-1/3"}>
      <div className="bg-slate-50/70 rounded-xl border border-slate-200/70 p-4 h-full">
        <h3 className="text-[11px] uppercase tracking-[0.12em] font-semibold text-ink-500 mb-1.5">{label}</h3>
        <div className="text-sm font-medium text-ink-900 break-words">{children}</div>
      </div>
    </div>
  );

  return (
    <div className="fixed inset-0 z-50 flex justify-center items-center bg-black/50">
      <div className="bg-white rounded-2xl shadow-sirius-lg w-full max-w-[1100px] max-h-[90vh] flex flex-col overflow-hidden">
        {/* HEADER */}
        <div className="px-6 md:px-8 py-5 border-b border-slate-200 bg-white">
          <h6 className="text-lg md:text-xl font-display font-bold text-ink-900 text-center">
            Detalles del Cliente
          </h6>
        </div>

        {/* BODY */}
        <div className="flex-1 min-h-0 overflow-y-auto px-6 md:px-8 py-6">
          <div className="flex flex-wrap gap-3">
            <Item label="RIF">{message.rif || "—"}</Item>
            <Item label="Razón social">{message.nombre || "—"}</Item>
            <Item label="Denominación comercial">{message.denominacion_comercial || "—"}</Item>
            <Item label="Teléfono">{message.telefono || "—"}</Item>
            <Item label="Correo electrónico">{message.email || "—"}</Item>
            <Item label="Dirección" full>{message.direccion || "—"}</Item>
            <Item label="Región">{formatText(message.region || '') || "—"}</Item>
            <Item label="Estado">{formatText(message.estado || '') || "—"}</Item>
            <Item label="Zona">{formatText(message.zona || '') || "—"}</Item>
            <Item label="Tipo de contribuyente">{formatText(message.tipo_contribuyente?.nombre || '') || "—"}</Item>
            <Item label="Condición">
              {message.activo == true ? (
                <span className="inline-block bg-emerald-500 text-white py-1 px-3 rounded-full text-xs font-bold">ACTIVO</span>
              ) : (
                <span className="inline-block bg-rose-500 text-white py-1 px-3 rounded-full text-xs font-bold">INACTIVO</span>
              )}
            </Item>
          </div>
        </div>

        {/* FOOTER */}
        <div className="shrink-0 w-full flex justify-center py-4 border-t border-slate-200 bg-white">
          <button
            onClick={onClose}
            className="px-6 py-2 bg-twilight-indigo-600 hover:bg-twilight-indigo-500 text-white font-semibold rounded-xl transition"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
}

export default ModalEndClients;
